import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, unref as _unref, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "row pt-3",
  style: {"border-top":"1px dashed rgba(106, 113, 133, 0.3)"}
}
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = { class: "f-w-700 pb-1" }
const _hoisted_5 = { class: "col-sm-6" }
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "col-sm-6" }
const _hoisted_8 = { class: "mb-3" }
const _hoisted_9 = { class: "col-sm-6" }
const _hoisted_10 = { class: "mb-3" }
const _hoisted_11 = { class: "col-sm-6" }
const _hoisted_12 = { class: "mb-3" }
const _hoisted_13 = { class: "col-sm-6" }
const _hoisted_14 = { class: "mb-3" }
const _hoisted_15 = { class: "col-sm-6" }
const _hoisted_16 = { class: "mb-3" }
const _hoisted_17 = { class: "col-sm-6" }
const _hoisted_18 = { class: "mb-3" }
const _hoisted_19 = { class: "col-sm-6" }
const _hoisted_20 = { class: "mb-3" }
const _hoisted_21 = { class: "col-sm-6" }
const _hoisted_22 = { class: "input-group" }
const _hoisted_23 = { class: "col-sm-6" }
const _hoisted_24 = { class: "input-group" }
const _hoisted_25 = { class: "col-sm-6" }
const _hoisted_26 = { class: "mt-3 checkbox-checked h-100 d-flex h-100 align-items-center" }
const _hoisted_27 = { class: "form-check" }
const _hoisted_28 = { class: "col-sm-6" }
const _hoisted_29 = { class: "mt-3 checkbox-checked h-100 d-flex h-100 align-items-center" }
const _hoisted_30 = { class: "form-check" }

import { computed, reactive, watch, onMounted, defineAsyncComponent } from 'vue'
import { useProductsStore } from '@/store/management/productsStore';
import type { Product } from '@/store/management/productsStore';


export default /*@__PURE__*/_defineComponent({
  __name: 'productBasic',
  setup(__props) {

const productAltLangModal = defineAsyncComponent(() => import('@/components/managementPages/productsPage/productAltLangModal.vue'))

const productStore = useProductsStore()

onMounted(() => {
    if (tempActiveProduct.value?.basic.productNumber) {
        const productGroup = tempActiveProduct.value
        const basicData = productGroup.basic
        compState.department = basicData.department
        compState.productNumber = basicData.productNumber
        compState.name = basicData.name
        compState.barcode = basicData.barcode
        compState.taxRate = basicData.taxRate
        compState.serviceCharge = basicData.serviceCharge
        compState.alternateName = basicData.alternateName
        compState.alternateName2 = basicData.alternateName2
        compState.displayOrder = basicData.displayOrder
        compState.singleItemSale = basicData.singleItemSale
        compState.showOnMenu = basicData.showOnMenu
        compState.altLangText = altDisplayText(tempActiveProduct.value.basic.altDisplayLang)
    }
})

const compState = reactive({
    department: '',
    productNumber: '',
    name: '',
    barcode: '',
    taxRate: '',
    serviceCharge: '',
    alternateName: '',
    alternateName2: '',
    displayOrder: 0,
    emptyBtn: 0,
    singleItemSale: false,
    showOnMenu: false,
    altLangText: ''
})

const departmentList = computed(() => {
    return productStore.getDepartmentList
})

const activeProduct = computed(() => {
    return productStore.getActiveProduct
})

const tempActiveProduct = computed(() => {
    return productStore.getTempActiveProduct
})

const activeProductId = computed(() => {
    return productStore.getActiveProductId
})

const altDisplayText = (langList: String[]) => {
    if (langList) {
        return langList.filter(lang => lang !== '').join('|')
    }
    return ''
}
watch(activeProductId, (newVal) => {
    if (newVal) {
        const productGroup = activeProduct.value
        const basicData = productGroup.basic
        compState.department = basicData.department
        compState.productNumber = basicData.productNumber
        compState.name = basicData.name
        compState.barcode = basicData.barcode
        compState.taxRate = basicData.taxRate
        compState.serviceCharge = basicData.serviceCharge
        compState.alternateName = basicData.alternateName
        compState.alternateName2 = basicData.alternateName2
        compState.displayOrder = basicData.displayOrder
        compState.singleItemSale = basicData.singleItemSale
        compState.showOnMenu = basicData.showOnMenu
        compState.altLangText = altDisplayText(tempActiveProduct.value.basic.altDisplayLang)
    }
}, { immediate: true });

watch(compState, (newVal) => {
    productStore.setTempActiveProduct({
        ...tempActiveProduct.value,
        basic: {
            ...tempActiveProduct.value.basic,
            department: newVal.department,
            productNumber: newVal.productNumber,
            name: newVal.name,
            barcode: newVal.barcode,
            taxRate: newVal.taxRate,
            serviceCharge: newVal.serviceCharge,
            alternateName: newVal.alternateName,
            alternateName2: newVal.alternateName2,
            displayOrder: newVal.displayOrder,
            singleItemSale: newVal.singleItemSale,
            showOnMenu: newVal.showOnMenu
        }
    } as Product)
}, { deep: true });

const displayOrderIncrement = () => {
    compState.displayOrder++
}

const displayOrderDecrement = () => {
    if (compState.displayOrder > 0) {
        compState.displayOrder--
    }
}

const onEditAltLang = () => {
    compState.altLangText = altDisplayText(tempActiveProduct.value.basic.altDisplayLang)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h6", _hoisted_4, "ProductNumber : " + _toDisplayString(compState.productNumber), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[13] || (_cache[13] = _createElementVNode("label", null, [
          _createElementVNode("h6", { class: "f-w-700" }, "Department")
        ], -1)),
        _withDirectives(_createElementVNode("select", {
          class: "form-select",
          "aria-label": "Department",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((compState.department) = $event))
        }, [
          _cache[12] || (_cache[12] = _createElementVNode("option", {
            value: "",
            disabled: ""
          }, "Department", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(departmentList.value, (department) => {
            return (_openBlock(), _createElementBlock("option", {
              key: department.id,
              value: department.name
            }, _toDisplayString(department.name), 9, _hoisted_6))
          }), 128))
        ], 512), [
          [_vModelSelect, compState.department]
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _cache[14] || (_cache[14] = _createElementVNode("label", null, [
            _createElementVNode("h6", { class: "f-w-700" }, "Product Name")
          ], -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((compState.name) = $event)),
            class: "form-control",
            type: "text",
            placeholder: "Name",
            maxlength: "32"
          }, null, 512), [
            [_vModelText, compState.name]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _cache[15] || (_cache[15] = _createElementVNode("label", null, [
            _createElementVNode("h6", { class: "f-w-700" }, "Barcode")
          ], -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((compState.barcode) = $event)),
            class: "form-control",
            type: "text",
            placeholder: "Name",
            maxlength: "128"
          }, null, 512), [
            [_vModelText, compState.barcode]
          ])
        ])
      ]),
      _cache[27] || (_cache[27] = _createElementVNode("div", { class: "col-sm-6" }, null, -1)),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _cache[17] || (_cache[17] = _createElementVNode("label", null, [
            _createElementVNode("h6", { class: "f-w-700" }, "Tax Rate")
          ], -1)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((compState.taxRate) = $event)),
            class: "form-select",
            "aria-label": "Tax Rate"
          }, _cache[16] || (_cache[16] = [
            _createElementVNode("option", {
              value: "",
              disabled: ""
            }, "Tax Rate", -1),
            _createElementVNode("option", { value: "Tax" }, "Tax", -1),
            _createElementVNode("option", { value: "Tax2" }, "Tax2", -1),
            _createElementVNode("option", { value: "Tax3" }, "Tax3", -1)
          ]), 512), [
            [_vModelSelect, compState.taxRate]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _cache[19] || (_cache[19] = _createElementVNode("label", null, [
            _createElementVNode("h6", { class: "f-w-700" }, "Service Charge")
          ], -1)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((compState.serviceCharge) = $event)),
            class: "form-select",
            "aria-label": "Service Charge"
          }, _cache[18] || (_cache[18] = [
            _createElementVNode("option", {
              value: "",
              disabled: ""
            }, "Service Charge", -1),
            _createElementVNode("option", { value: "ser" }, "Ser", -1),
            _createElementVNode("option", { value: "ser2" }, "Ser2", -1),
            _createElementVNode("option", { value: "ser3" }, "Ser3", -1)
          ]), 512), [
            [_vModelSelect, compState.serviceCharge]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _cache[20] || (_cache[20] = _createElementVNode("label", null, [
            _createElementVNode("h6", { class: "f-w-700" }, "Alternative Product Name")
          ], -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((compState.alternateName) = $event)),
            class: "form-control",
            type: "text",
            placeholder: "Name",
            maxlength: "32"
          }, null, 512), [
            [_vModelText, compState.alternateName]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _cache[21] || (_cache[21] = _createElementVNode("label", null, [
            _createElementVNode("h6", { class: "f-w-700" }, "Alternative Product Name 2")
          ], -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((compState.alternateName2) = $event)),
            class: "form-control",
            type: "text",
            placeholder: "Name",
            maxlength: "32"
          }, null, 512), [
            [_vModelText, compState.alternateName2]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _cache[22] || (_cache[22] = _createElementVNode("label", null, [
            _createElementVNode("h6", { class: "f-w-700" }, "Alternative Display Language")
          ], -1)),
          _withDirectives(_createElementVNode("input", {
            class: "form-control",
            type: "text",
            placeholder: "Alternative Display Language",
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((compState.altLangText) = $event)),
            maxlength: "32",
            readonly: "",
            "data-bs-toggle": "modal",
            "data-original-title": "test",
            "data-bs-target": "#alt-lang-modal"
          }, null, 512), [
            [_vModelText, compState.altLangText]
          ])
        ])
      ]),
      _cache[28] || (_cache[28] = _createElementVNode("div", { class: "col-sm-6" }, null, -1)),
      _createElementVNode("div", _hoisted_21, [
        _cache[23] || (_cache[23] = _createElementVNode("label", null, [
          _createElementVNode("h6", { class: "f-w-700" }, "Display Order")
        ], -1)),
        _createElementVNode("div", _hoisted_22, [
          _withDirectives(_createElementVNode("input", {
            class: "form-control",
            type: "number",
            placeholder: "Threshold",
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((compState.displayOrder) = $event))
          }, null, 512), [
            [_vModelText, compState.displayOrder]
          ]),
          _createElementVNode("button", {
            class: "btn btn-outline-secondary rounded-end-0",
            type: "button",
            onClick: displayOrderDecrement
          }, "-"),
          _createElementVNode("button", {
            class: "btn btn-outline-secondary rounded-start-0",
            type: "button",
            onClick: displayOrderIncrement
          }, "+")
        ])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _cache[24] || (_cache[24] = _createElementVNode("label", null, [
          _createElementVNode("h6", { class: "f-w-700" }, "Empty Button")
        ], -1)),
        _createElementVNode("div", _hoisted_24, [
          _withDirectives(_createElementVNode("input", {
            class: "form-control",
            type: "number",
            placeholder: "Threshold",
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((compState.emptyBtn) = $event))
          }, null, 512), [
            [_vModelText, compState.emptyBtn]
          ]),
          _createElementVNode("button", {
            class: "btn btn-outline-secondary rounded-end-0",
            type: "button",
            onClick: displayOrderDecrement
          }, "-"),
          _createElementVNode("button", {
            class: "btn btn-outline-secondary rounded-start-0",
            type: "button",
            onClick: displayOrderIncrement
          }, "+")
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _withDirectives(_createElementVNode("input", {
              class: "form-check-input",
              id: "Single-Item-Select",
              type: "checkbox",
              value: "",
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((compState.singleItemSale) = $event))
            }, null, 512), [
              [_vModelCheckbox, compState.singleItemSale]
            ]),
            _cache[25] || (_cache[25] = _createElementVNode("label", {
              class: "form-check-label",
              for: "Single-Item-Select"
            }, "Single Item Select", -1))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _withDirectives(_createElementVNode("input", {
              class: "form-check-input",
              id: "Show-on-Menu",
              type: "checkbox",
              value: "",
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((compState.showOnMenu) = $event))
            }, null, 512), [
              [_vModelCheckbox, compState.showOnMenu]
            ]),
            _cache[26] || (_cache[26] = _createElementVNode("label", {
              class: "form-check-label",
              for: "Show-on-Menu"
            }, "Show on Menu", -1))
          ])
        ])
      ])
    ]),
    _createVNode(_unref(productAltLangModal), { onOnSave: onEditAltLang })
  ], 64))
}
}

})